import React from 'react';
import PropTypes from 'prop-types';
import AdvTopLevelWorkflow from '../AdvWorkflow/AdvTopLevelWorkflowContainer';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../js/app/react/validators';
import PersonalInfoWorkflow from '../PersonalInfoWorkflow/PersonalInfoWorkflowContainer';
import TaxesWorkflow from '../TaxesWorkflow/TaxesWorkflowContainer';
import IncomeWorkflow from '../IncomeWorkflow/IncomeWorkflowContainer';
import ExpensesWorkflow from '../ExpensesWorkflow/ExpensesWorkflowContainer';
import AccountsWorkflow from '../AccountsWorkflow/AccountsWorkflowContainer';
import ItemDescription from './Steps/ItemDescription/ItemDescriptionContainer';
import PurchaseAmount from './Steps/PurchaseAmount/PurchaseAmountContainer';
import PurchaseYear from './Steps/PurchaseYear/PurchaseYearContainer';
import LargePurchaseWorkflowCRUD from './Steps/LargePurchaseGoalsCRUD/LargePurchaseGoalsCRUDContainer';
import { useDocumentTitle } from '../../_hooks/useDocumentTitle';

const LargePurchaseWorkflowView = ({
  workflowId,
  clientId,
  outputFunction,
  itemName,
  itemId,
  isMobile,
  goToSummaryWhenReady,
  selectedGoalId,
  shouldSkipSummary,
  ...rest
}) => {
  useDocumentTitle('Save for Large Purchase');

  return (
    <AdvTopLevelWorkflow
      {...rest}
      selectedGoalId={selectedGoalId}
      clientId={clientId}
      hasAutoOutput={shouldSkipSummary}
      workflowId={workflowId}
      analyticsWorkflowStarted="large_purchase_workflow_started"
      outputFunction={outputFunction(clientId, itemName, itemId)}
      steps={[
        LargePurchaseWorkflowCRUD,
        PersonalInfoWorkflow,
        TaxesWorkflow,
        IncomeWorkflow,
        ExpensesWorkflow,
        ItemDescription,
        PurchaseAmount,
        PurchaseYear,
        AccountsWorkflow,
      ]}
    />
  );
};

LargePurchaseWorkflowView.propTypes = {
  itemName: PropTypes.func.isRequired,
  outputFunction: PropTypes.func.isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
};

export default LargePurchaseWorkflowView;
